import {Button, Col, Row, Table} from "react-bootstrap";
import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {useGetMultiImports} from "../../api/importsV2/useMultiImports";
import {useDisableMultiImport, useEnableMultiImport} from "../../api/importsV2/useDisableEnableMultiImports";
import {Loading} from "../../components/Loading";
import {
    LeasePackageMultiImportDto,
    LeasePackageMultiImportSimpleDto
} from "../../model/Imports";
import notifier from "simple-react-notifications2";
import {
    DatatableWrapper,
    Filter,
    Pagination,
    PaginationOptions,
    TableBody,
    TableColumnType,
    TableHeader
} from "react-bs-datatable";
import Container from "react-bootstrap/Container";
import {TablePaginationOptionsParameters} from "react-bs-datatable/lib/esm/components/DatatableWrapper";

type ArrayElementType = LeasePackageMultiImportSimpleDto & {
    button: React.ReactNode;
};

export function ImportsV2() {
    const navigate = useNavigate();

    const {loading, data, error, execute} = useGetMultiImports();
    const {loading: loadingEnable, error: errorEnable, execute: executeEnable} = useEnableMultiImport();
    const {loading: loadingDisable, error: errorDisable, execute: executeDisable} = useDisableMultiImport();

    useEffect(() => {
        execute()
    }, []);

    function enable(id: number) {
        executeEnable(id).then(r => {
            execute(); notifier.success('Sucess')
        }).catch(e => {execute(); notifier.error('Error')})
    }

    function disable(id: number) {
        executeDisable(id).then(r => {
            execute(); notifier.success('Sucess')
        }).catch(e => {execute(); notifier.error('Error')})
    }

    if(loading) return (<Loading/>)
    if(!data) return (<>No data</>)

    const header: TableColumnType<ArrayElementType>[] = [
        {title: 'Id', prop: 'id', isSortable: true, isFilterable: true},
        {title: 'Date', prop: 'created', isSortable: true, isFilterable: true,
            cell: (row) => (<>{`${row.created}`}</>)},
        {title: 'Active', prop: 'enabled', isSortable: true, isFilterable: true,
            cell: (row) => {
                if(row.enabled) return (<>Active</>)
                else return (<>Inactive</>)
            }},
        {title: 'File', prop: 'filename', isSortable: true, isFilterable: true,
            cell: (row) => (<>{`${row.filename}`}</>)},
        {
            prop: "button",
            cell: (row) => (
                <Button variant="primary" size="sm"
                        onClick={() => edit(row.id)}>
                    {'Edit'}
                </Button>
            )
        }
    ];

    function edit(id: number) {
        navigate(`/imports-v2/${id}`)
    }

    const paginationProps={
        initialState: {
            rowsPerPage: 20,
            options: [5, 10, 20, 50, 100]
        }
    } as TablePaginationOptionsParameters

    function getSortedImports() {
        return data.sort((a, b) => b.id - a.id)
    }

    return (
        <>
            <Container>
                    <Row>
                        <div className="mt-2 mb-5 d-grid gap-2 col-md-8 col-12 mx-auto">
                            <Button className="mb-5" variant="primary" type="submit" onClick={() => navigate('/imports-v2-new')}>
                                New
                            </Button>
                        </div>
                    </Row>
                    <Row>
                        <DatatableWrapper body={getSortedImports() as ArrayElementType[]} headers={header}
                                          paginationOptionsProps={paginationProps}
                                          sortProps={{initialState: {prop:'id', order: 'desc'}}}
                        >
                            <Table>
                                <TableHeader/>
                                <TableBody/>
                            </Table>
                            <Row>
                                <Col xs={12}  className="d-flex flex-col justify-content-end align-items-end">
                                    <PaginationOptions />
                                    <Pagination />
                                </Col>
                            </Row>
                        </DatatableWrapper>
                    </Row>
                </Container>
        </>
    )
}

export function MultiImportHeader(
    props: {import: LeasePackageMultiImportDto}
) {


    return (
        <>
            <Row>
                <Col>{props.import.id}</Col>
                <Col>{props.import.created.toString()}</Col>
                <Col>{props.import.enabled ? 'Active' : 'Disabled'}</Col>
                {(props.import.filename && props.import.filename.trim().length > 0) ? (
                    <Col xs={7}>{props.import.filename}</Col>
                ): (<></>)}
            </Row>
        </>
    )
}